import React from "react";
import { Link } from "react-router-dom";

/**
 * Renders the footer
 *
 * @param   {Object}  props  Includes boolean for hideFooter
 *
 * @return  {JSX}         Returns the footer element
 */
export default function Footer({ hideFooter }) {
  if (hideFooter) {
    return null;
  }
  return (
    <footer className="light-links">
      <div className="row text-center justify-spread align-center">
        <div className="col">
          <p>For entertainment purposes only.</p>
        </div>
      </div>
      <div className="row text-center justify-spread align-center">
        <div className="col">
          <p className="notranslate">
            &copy; 2017 - {new Date().getFullYear()} &nbsp;
            <a href="https://agirlcreatedthis.com">A Girl Created This, LLC</a>. All rights reserved.
          </p>
        </div>
        <div className="col">
          <p>
            <Link to="/releases">Release Notes</Link>
            <span className="margin-horizontal-sm">|</span>
            <Link to="/terms">Terms of Use</Link>
            <span className="margin-horizontal-sm">|</span>
            <Link to="/privacy">Cookies &amp; Privacy Policy</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
